if (!customElements.get('oyster-purchase')) {
  customElements.define('oyster-purchase', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.form = this.querySelector('form');
      this.select = this.querySelector('[data-variant-select]');
      this.submit = this.querySelector('[data-submit]');
      this.price = this.querySelector('[data-current-price]');
      this.comparePrice = this.querySelector('[data-compare-price]:not(option)');
      this.priceSummary = this.querySelector('[data-price-summary]');
      this.status = this.querySelector('[data-status]');
      if (!this.form || !this.select || !this.submit || !this.price || !this.comparePrice || !this.priceSummary || !this.status) return;

      const signal = this.abort.signal;
      this.matchingFields = Array.from(this.querySelectorAll('[data-matching-property]'));
      this.variantCards = Array.from(this.querySelectorAll('[data-exact-variant]'));
      this.variantCards.forEach(card => {
        card.addEventListener('click', () => {
          const option = Array.from(this.select.options).find(item => item.value === card.dataset.exactVariant);
          if (!option || option.disabled || option.dataset.available !== 'true') return;
          this.select.value = option.value;
          this.select.dispatchEvent(new Event('change', { bubbles: true }));
        }, { signal });
      });
      if (this.variantCards.length) {
        this.querySelector('[data-native-configuration]').hidden = true;
        this.querySelector('[data-variant-cards]').hidden = false;
      }
      this.select.addEventListener('change', () => this.update(true), { signal });
      this.form.addEventListener('submit', event => {
        const selected = this.selectedVariant();
        if (!selected?.available) {
          event.preventDefault();
          this.update(false);
          this.status.textContent = this.dataset.selectionMessage;
          this.status.hidden = false;
          if (!this.select.closest('[hidden]')) this.select.focus();
          return;
        }
        this.matchingFields.forEach(input => { input.value = input.value.trim(); });
      }, { signal });
      window.addEventListener('popstate', () => {
        this.selectFromUrl();
        this.update(false);
      }, { signal });
      this.selectFromUrl();
      this.update(false);
    }

    disconnectedCallback() {
      this.abort?.abort();
    }

    isProductRoute() {
      const productUrl = new URL(this.dataset.productUrl, window.location.href);
      return productUrl.origin === window.location.origin && productUrl.pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '');
    }

    selectFromUrl() {
      if (!this.isProductRoute()) return;
      const id = new URL(window.location.href).searchParams.get('variant');
      if (id && Array.from(this.select.options).some(option => option.value === id)) this.select.value = id;
    }

    selectedVariant() {
      const option = this.select.selectedOptions[0];
      if (!option?.value) return null;
      return {
        id: option.value,
        title: option.dataset.title,
        price: option.dataset.price,
        priceCents: Number(option.dataset.priceCents),
        comparePrice: option.dataset.comparePrice,
        available: option.dataset.available === 'true' && !option.disabled,
        image: option.dataset.imageUrl ? {
          id: option.dataset.imageId,
          src: option.dataset.imageUrl,
          alt: option.dataset.imageAlt
        } : null
      };
    }

    update(updateUrl) {
      const variant = this.selectedVariant();
      this.variantCards?.forEach(card => { card.setAttribute('aria-pressed', String(card.dataset.exactVariant === variant?.id)); });
      this.priceSummary.hidden = false;
      this.price.textContent = variant?.price || this.dataset.unavailableLabel;
      this.comparePrice.textContent = variant?.comparePrice || '';
      this.comparePrice.hidden = !variant?.comparePrice;
      this.submit.disabled = !variant?.available;
      this.submit.textContent = variant?.available ? this.dataset.addLabel : variant ? this.dataset.soldOutLabel : this.dataset.unavailableLabel;
      const selectionTitle = this.querySelector('[data-selection-title]');
      if (selectionTitle) selectionTitle.textContent = variant?.title || this.dataset.unavailableLabel;
      this.status.textContent = '';
      this.status.hidden = true;
      if (updateUrl && variant && this.isProductRoute()) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState(window.history.state, '', url);
      }
      this.select.dispatchEvent(new Event('oyster:selection-sync'));
      this.dispatchEvent(new CustomEvent('oyster:variant-change', {
        bubbles: true,
        detail: { variant, productId: this.dataset.productId, formId: this.form.id }
      }));
    }
  });
}
